
import { useAppMutation } from '@/shared/hooks/useAppMutation';
import { AppError } from '@/shared/types/AppError';
import { HookOptions } from '@/shared/types/HookOptions';
import { screenplayAIService } from '../services/screenplay.ai.service';
import { SceneGenerationOptions, ScreenplayOutlineGenerationOptions, ScreenplaySuggestionProps, SerializedContent } from '../types';

export const useGenerateScreenplayOutlineMutation = (options?: HookOptions<SerializedContent[], AppError, ScreenplayOutlineGenerationOptions>) => {
    return useAppMutation<SerializedContent[], AppError, ScreenplayOutlineGenerationOptions>({
        mutationFn: (data: ScreenplayOutlineGenerationOptions) => screenplayAIService.generateScreenplayOutline(data),
    }, options)
}

export const useGenerateSceneMutation = (options?: HookOptions<SerializedContent[], AppError, SceneGenerationOptions>) => {
    return useAppMutation<SerializedContent[], AppError, SceneGenerationOptions>({
        mutationFn: (data: SceneGenerationOptions) => screenplayAIService.generateScene(data),
    }, options)
}

export const useModifySceneMutation = (options?: HookOptions<SerializedContent[], AppError, SceneGenerationOptions>) => {
    return useAppMutation<SerializedContent[], AppError, SceneGenerationOptions>({
        mutationFn: (data: SceneGenerationOptions) => screenplayAIService.modifyScene(data),
    }, options)
}

export const useScreenplaySuggestionMutation = (options?: HookOptions<string, AppError, ScreenplaySuggestionProps>) => {
    return useAppMutation<string, AppError, ScreenplaySuggestionProps>({
        mutationFn: (data: ScreenplaySuggestionProps) => screenplayAIService.generateScreenplaySuggestions(data),
    }, options)
}
